import React, { Component } from "react";
import DeviceTypeIcon from "../../../../components/DeviceTypeIcon";
import {withNamespaces} from "react-i18next";
import NetworkDeviceActionButtons from "../_components/NetworkDeviceActionButtons";
import DiagnosticModeButton from "../../../../components/DiagnosticModeButton";
import IgnoreScheduleModeButton from "../../../../components/IgnoreScheduleModeButton";

class NetworkDeviceListMobileViewItem extends Component {
    render() {
        const { t, item } = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-2 d-flex align-items-center justify-content-center">
                        <DeviceTypeIcon customClass={item.isOnline ? "status-online" : "status-offline"} type={item.deviceType.label } />
                    </div>
                    <div className="col-5">
                        <small><b>{item.label}</b></small>
                        <p><small>{item.description}</small></p>
                    </div>
                    <div className="col-5 d-flex align-items-center justify-content-end button-mobile">
                        <NetworkDeviceActionButtons row={item} isMobile={true} />
                    </div>
                </div>

                <div className="row mobile-font justify-content-end">
                    <div className="col"><DiagnosticModeButton size="sm" networkDevice={item} /></div>
                    <div className="col"><IgnoreScheduleModeButton size="sm" networkDevice={item} /></div>
                </div>
            </React.Fragment>

        );
    }
}
export default withNamespaces()(NetworkDeviceListMobileViewItem);
